import React, { useEffect } from 'react';
import './css/footer.css';
import contact from '../../data/layouts/contact';
import { Link } from 'react-router-dom';
import getValue from '../../format/getValue';

const Footer = ({
  infoCompany = [],
  contactItems = [],
  combinedData = [],
  infoFooter = [],
}) => {
  useEffect(() => {
    window.FB?.XFBML.parse();
  }, []);

  const getFooterItem = (key) => infoFooter.find((item) => item.key === key);
  const getFooterItems = (key) => infoFooter.filter((item) => item.key === key);

  const nameCompany = getValue(infoCompany, 'name')?.value || '';
  const facebookValue = getValue(infoCompany, 'facebook')?.url || '';

  const aboutCompany = getFooterItem('about_company');
  const map = getFooterItem('map');
  const copyright = getFooterItem('copyright');
  const policy = getFooterItems('policy');

  return (
    <section>
      <footer className="footer">
        <div
          className="layer"
          style={{
            backgroundImage: 'url("/images/wavy-curve.png")',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <div className="container">
            <div className="row justify-content-between">
              {/* Cột 1 - Logo + liên hệ + mạng xã hội */}
              <div className="col-lg-4 col-md-6 position-relative">
                <Link className="logo" to="/" title={nameCompany}>
                  <img src={contact.logo} alt={nameCompany} loading="lazy" />
                </Link>

                <h3>Thông tin liên hệ</h3>
                {contactItems.map((item, index) => (
                  <div className="text-white mb-3" key={index}>
                    <img
                      src={`/images/icons/${item.icon}`}
                      alt={item.data?.title}
                      style={{
                        width: '20px',
                        maxHeight: '24px',
                        marginRight: '5px',
                      }}
                      loading="lazy"
                    />
                    {item.data?.value}
                  </div>
                ))}

                <div className="social-networks mb-md-0">
                  {combinedData.map((network, index) =>
                    network.iconWhite && network.url ? (
                      <a
                        key={index}
                        className="me-2 me-sm-2"
                        href={network.url}
                        title={network.name}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={network.iconWhite}
                          alt={network.name}
                          className="icon"
                          loading="lazy"
                        />
                      </a>
                    ) : null
                  )}
                </div>
              </div>

              {/* Cột 2 - Chính sách + Facebook */}
              <div className="footer_column col-lg-4 col-md-6 mt-4">
                <div className="our-agency">
                  <h3>Chính sách</h3>
                  <ul>
                    {policy.map((item, index) => (
                      <li key={index} className="mb-3">
                        <Link
                          className="link-policy"
                          to={item.url || '#'}
                          title={item.title}
                        >
                          {item.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>

                <div
                  className="fb-page mt-auto w-100 "
                  data-href={facebookValue}
                  data-tabs="timeline"
                  data-height="130"
                  data-small-header="false"
                  data-adapt-container-width="true"
                  data-hide-cover="false"
                  data-show-facepile="true"
                ></div>
              </div>

              {/* Cột 3 - Giới thiệu + Google Map */}
              <div className="col-lg-4 col-md-12 pl-lg-0 mt-4">
                <div
                  className="row d-flex flex-column footer_column"
                  style={{ minHeight: '100%', flexGrow: 1 }}
                >
                  <div className="footer_third col-lg-12 col-md-6">
                    <h3>{aboutCompany?.title}</h3>
                    <div
                      className="text-white"
                      style={{ textAlign: 'justify' }}
                    >
                      <span>{aboutCompany?.value}</span>
                    </div>
                  </div>

                  <div
                    className="footer_third_end mt-auto col-lg-12 col-md-6"
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      paddingTop: '20px',
                    }}
                  >
                    <iframe
                      src={map?.url}
                      width="100%"
                      height="130"
                      style={{ border: 'none', borderRadius: '4px' }}
                      loading="lazy"
                      title="Google Map"
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="copyright sub-footer">
        Design by{' '}
        <a
          href={copyright?.url}
          className="text-white fw-bold"
          target="_blank"
          rel="noopener noreferrer"
        >
          {copyright?.value}
        </a>
      </div>
    </section>
  );
};

export default Footer;
